import React, { useRef, useState, useEffect } from "react";
import { FaPlay, FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import "./style.css";

const ReelVideo = ({
  src,
  height = "100vh",
  autoPlay = true,
  loop = true,
  muted: mutedProp = true,
  showControls = true,
  thumbnail,
}) => {
  const videoRef = useRef(null);
  const wrapperRef = useRef(null);

  const [paused, setPaused] = useState(!autoPlay);
  const [muted, setMuted] = useState(mutedProp);
  const [isBuffering, setIsBuffering] = useState(true);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!videoRef.current) return;
        if (entry.isIntersecting) {
          videoRef.current.play();
          setPaused(false);
        } else {
          videoRef.current.pause();
          setPaused(true);
        }
      },
      { threshold: 0.7 }
    );

    observer.observe(wrapperRef.current);
    return () => observer.disconnect();
  }, []);

  const togglePlay = () => {
    paused ? videoRef.current.play() : videoRef.current.pause();
    setPaused(!paused);
  };

  const toggleMute = () => setMuted((m) => !m);

  return (
    <div ref={wrapperRef} className="reel-container" style={{ height }}>
      {!videoReady && thumbnail && (
        <img src={thumbnail} alt="" className="reel-thumbnail" />
      )}

      <video
        ref={videoRef}
        src={src}
        muted={muted}
        loop={loop}
        playsInline
        preload="none"
        className="reel-video"
        onCanPlay={() => {
          setVideoReady(true);
          setIsBuffering(false);
        }}
        onWaiting={() => setIsBuffering(true)}
        onPlaying={() => setIsBuffering(false)}
      />

      {isBuffering && (
        <img src={require("../../Pages/images/loader.gif")} alt="loading" className="reel-loader" />
      )}
      {showControls && videoReady && (
        <>
          {paused && (
            <div className="reel-play-btn" onClick={togglePlay}>
              <FaPlay />
            </div>
          )}

          <div className="reel-mute-btn" onClick={toggleMute}>
            {muted ? <FaVolumeMute /> : <FaVolumeUp />}
          </div>

          <div className="reel-touch-layer" onClick={togglePlay} />
        </>
      )}
    </div>
  );
};

export  {ReelVideo};
